import * as React from "react";
import Svg, { Path } from "react-native-svg";
const SVGComponent = (props) => (
  <Svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Path
      d="M19.7778 2H4.22222C2.98889 2 2 3 2 4.22222V19.7778C2 21 2.98889 22 4.22222 22H19.7778C21.0111 22 22 21 22 19.7778V4.22222C22 3 21.0111 2 19.7778 2ZM9.77778 17.5556L4.22222 12L5.78889 10.4333L9.77778 14.4111L18.2111 5.97778L19.7778 7.55556L9.77778 17.5556Z"
      fill="#E40046"
    />
  </Svg>
);
export default SVGComponent;
